import axios from 'axios';

export default {
  state: {
    user_address: [],
    user_addressLoading: false,
    user_addressLoaded: null,
    user_addressError: false
  },
  mutations: {
    SET_USER_ADDRESS(state, user_address) {
      state.user_address = user_address.data;
      state.user_addressLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_USER_ADDRESS_LOADING(state, status) {
      state.user_addressLoading = status;
    },
    SET_USER_ADDRESS_ERROR(state, error) {
      state.user_addressError = error;
    },
    UNSET_USER_ADDRESS(state) {
      state.user_addressLoaded = false;
      state.user_addressLoading = false;
      state.user_address = [];
    },
  },
  actions: {
    async fetchUserAddress({ commit, state }) {

      commit('UNSET_USER_ADDRESS');

      try {
        commit('SET_USER_ADDRESS_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/user/address/');
        commit('SET_USER_ADDRESS', response.data);
        commit('SET_USER_ADDRESS_ERROR', null);
      } catch (error) {
        commit('SET_USER_ADDRESS_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching user_address:', error);
      } finally {
        commit('SET_USER_ADDRESS_LOADING', false);
      }
    }
  },
  getters: {
    user_address: state => state.user_address,
    user_addressLoading: state => state.user_addressLoading,
    user_addressError: state => state.user_addressError,
    user_addressLoaded: state => state.user_addressLoaded
  }
}